import { RootState } from "@store/reducers";
import { HiringCompanyType } from "@utils/constants";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

type InterviewCreateAccessGuardProps = {
  children?: React.ReactNode;
};

const InterviewCreateAccessGuard: React.FC<InterviewCreateAccessGuardProps> = ({
  children,
}) => {
  const { user } = useSelector((state: RootState) => state.auth);
  const isTeamMember =
    Number(user?.hiringCompanyType) === HiringCompanyType.TEAM_MEMBER;

  if (isTeamMember) {
    return <Navigate to="/calendar/meeting/scheduling" replace />;
  }

  if (children) return <>{children}</>;
  return <Outlet />;
};

export default InterviewCreateAccessGuard;
